import {WithSummaryModel} from '../../../../common/entity/dto/plain/withSummary.model';
import {ReportDefinitionSummaryModel} from './reportDefinitionSummary.model';
import {ReportDefinitionComponentModel} from './reportDefinitionComponent.model';
import {
        CommunicationContentModelSummaryModel
} from '../../../../communication/content-model/api/entity/communicationContentModelSummary.model';
import {ReportDefinitionEmailConfigurationModel} from "./reportDefinitionEmailConfiguration.model";

export class ReportDefinitionModel extends WithSummaryModel<ReportDefinitionSummaryModel> {
        components: ReportDefinitionComponentModel[] = [];
        defaultContent: string;
        defaultIntro: CommunicationContentModelSummaryModel;
        defaultSalutation: CommunicationContentModelSummaryModel;
        emailConfigurations: ReportDefinitionEmailConfigurationModel[] = [];

}
